import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'pay-manage';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    payDetails: '',
    payId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    billCode: ''
}
export const mutations = {
    setPayDetails(state, data) {
        state.payDetails = data
    },
    setPayIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setPayId(state, data) {
        state.payId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setPayRouterUrl(state, url) {
        state.routerUrl = url
    },
    setPayIsView(state, flag) {
        state.isView = flag
    },
    setPayDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/pay-manage/index.js